/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ArrowLeft/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ArrowLeft({
  children,
  viewPath = "/DesignSystem/Svgs/ArrowLeft",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 16,
  height = 16,
  fill = "none",
  stroke = "#B5B5B5"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="ArrowLeft.Svg"
  data-view-path={viewPath}
 viewBox="0 0 16 16"
 style={{'--as-1-19BFVb': alignSelf,'--mt-2-19BFVb': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-19BFVb': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-19BFVb': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-19BFVb': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-19BFVb': opacity,'--w-7-19BFVb': typeof width === 'number' ? `${width}px` : width,'--h-8-19BFVb': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="ArrowLeft.SvgPath"
  data-view-path={viewPath}
 strokeWidth={2}
 strokeMiterlimit={10}
 d="M11.2 14.4L4.8 8l6.4-6.4"
 style={{'--f-9-19BFVb': fill,'--s-10-19BFVb': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}